export default class inputOperator{
    constructor(){
        return {
            restrict: 'E',
            template: require('../../../../views/segment/input-operator.html'),
            scope: {
                value: '=ngModel',
                field: '&',
                operatorGroups: '@',
                forStatistic: '='
            },
            controller: ['$scope', '$element', '$attrs', '$q', '$filter', (scope, element, attr, $q, $filter) => {

                var templates = {
                    'text': '',
                    'single': '<input type="text" ng-model="value">',
                    'multiple': '',
                    'json': '<input type="text" ng-model="value">',
                    'datetime': '<input type="text" ng-model="value">',
                    'date': '<input type="text" ng-model="value">',
                    'time': '<input type="text" ng-model="value">'
                };

                var getField = (fieldId, groups) => {
                    var index = _.findIndex(groups, (group) => {
                        return group.fieldId == fieldId;
                    });

                    if (index > -1) {
                        return groups[index];
                    }
                };

                // Use this for UI-select that can't bind to value
                scope.$watch('operator.value', (newVal, oldVal) => {
                    if (newVal != oldVal) {
                        scope.value = scope.operator.value
                    }
                });

                scope.operator = {
                    value: scope.value
                };

                if (scope.forStatistic) {
                    scope.selections = {
                        operators: [
                            {value: 'is_not_empty', text: $filter('translate')('SUBSCRIBER:SHOW:ACTIVITY:OPERATOR:EXISTS')},
                            {value: 'is_empty', text: $filter('translate')('SUBSCRIBER:SHOW:ACTIVITY:OPERATOR:NOT_EXISTS')},
                        ]
                    }
                }

                // Get group data async, because it will load after the field
                var hasGroups = () => {
                    var deferred = $q.defer();

                    if (scope.operatorGroups.length) {
                        deferred.resolve()
                    }

                    scope.$watch('operatorGroups', (newVal, oldVal) => {
                        if (newVal != oldVal) {
                            deferred.resolve()
                        }
                    });
                    return deferred.promise
                };

                hasGroups().then(() => {
                    scope.$watch(scope.field, (newVal, oldVal) => {
                        if (newVal !== oldVal) {
                            scope.operator.value = null;
                        }
                        if (newVal == null) {
                            return
                        }

                        scope.customField = getField(newVal, scope.$eval(scope.operatorGroups));

                        if (!scope.customField || scope.forStatistic) {
                            return
                        }

                        if (scope.customField.fieldType === "multiple") {
                            scope.selections = {
                                operators: [
                                    {value: 'contains', text: $filter('translate')('SEGMENTATION:SELECTION:CONTAINS')},
                                    {value: 'absent', text: $filter('translate')('SEGMENTATION:SELECTION:ABSENT')}
                                ]
                            }
                        } else if (['datetime', 'date', 'time'].indexOf(scope.customField.fieldType) > -1 ) {
                            scope.selections = {
                                operators: [
                                    { value: 'eq', text: $filter('translate')('SEGMENTATION:SELECTION:EQ') },
                                    { value: 'ne', text: $filter('translate')('SEGMENTATION:SELECTION:NE') },
                                    { value: 'gte', text: $filter('translate')('SEGMENTATION:SELECTION:GTE') },
                                    { value: 'lte', text: $filter('translate')('SEGMENTATION:SELECTION:LTE') },
                                    { value: 'min_days', text: $filter('translate')('SEGMENTATION:SELECTION:MIN_DAYS') },
                                    { value: 'max_days', text: $filter('translate')('SEGMENTATION:SELECTION:MAX_DAYS') },
                                    { value: 'is_days', text: $filter('translate')('SEGMENTATION:SELECTION:IS_DAYS') },
                                    { value: 'is_empty', text: $filter('translate')('SEGMENTATION:SELECTION:IS_EMPTY') },
                                    { value: 'yearly', text: $filter('translate')('SEGMENTATION:SELECTION:YEARLY') },
                                ]
                            }
                        } else if (scope.customField.fieldType === 'language') {
                            scope.selections = {
                                operators: [
                                    { value: 'eq', text: $filter('translate')('SEGMENTATION:SELECTION:EQ') },
                                    { value: 'ne', text: $filter('translate')('SEGMENTATION:SELECTION:NE') },
                                ]
                            }
                        } else if (scope.customField.fieldType === 'suppression') {
                            scope.selections = {
                                operators: [
                                    { value: 'eq', text: $filter('translate')('SEGMENTATION:SELECTION:EQ') },
                                    { value: 'ne', text: $filter('translate')('SEGMENTATION:SELECTION:NE') },
                                ]
                            }
                        } else if (scope.customField.fieldType === 'email') {
                            scope.selections = {
                                operators: [
                                    { value: 'eq', text: $filter('translate')('SEGMENTATION:SELECTION:EQ') },
                                    { value: 'ne', text: $filter('translate')('SEGMENTATION:SELECTION:NE') },
                                    { value: 'contains', text: $filter('translate')('SEGMENTATION:SELECTION:CONTAINS') },
                                    { value: 'absent', text: $filter('translate')('SEGMENTATION:SELECTION:ABSENT') },
                                    { value: 'is_not_empty', text: $filter('translate')('SEGMENTATION:SELECTION:IS_NOT_EMPTY') },
                                    { value: 'is_empty', text: $filter('translate')('SEGMENTATION:SELECTION:IS_EMPTY') },
                                ]
                            }
                        } else if (scope.customField.fieldType === 'phone_number') {
                            scope.selections = {
                                operators: [
                                    { value: 'eq', text: $filter('translate')('SEGMENTATION:SELECTION:EQ') },
                                    { value: 'ne', text: $filter('translate')('SEGMENTATION:SELECTION:NE') },
                                    { value: 'contains', text: $filter('translate')('SEGMENTATION:SELECTION:CONTAINS') },
                                    { value: 'absent', text: $filter('translate')('SEGMENTATION:SELECTION:ABSENT') },
                                    { value: 'is_not_empty', text: $filter('translate')('SEGMENTATION:SELECTION:IS_NOT_EMPTY') },
                                    { value: 'is_empty', text: $filter('translate')('SEGMENTATION:SELECTION:IS_EMPTY') },
                                ]
                            }
                        } else {
                            scope.selections = {
                                operators: [
                                    { value: 'eq', text: $filter('translate')('SEGMENTATION:SELECTION:EQ') },
                                    { value: 'ne', text: $filter('translate')('SEGMENTATION:SELECTION:NE') },
                                    { value: 'gte', text: $filter('translate')('SEGMENTATION:SELECTION:GTE') },
                                    { value: 'lte', text: $filter('translate')('SEGMENTATION:SELECTION:LTE') },
                                    { value: 'contains', text: $filter('translate')('SEGMENTATION:SELECTION:CONTAINS') },
                                    { value: 'absent', text: $filter('translate')('SEGMENTATION:SELECTION:ABSENT') },
                                    { value: 'is_not_empty', text: $filter('translate')('SEGMENTATION:SELECTION:IS_NOT_EMPTY') },
                                    { value: 'is_empty', text: $filter('translate')('SEGMENTATION:SELECTION:IS_EMPTY') },
                                ]
                            }
                        }
                    })
                })
            }]

        }
    }
}
